// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2391":"aa0ff034c49e5245","3488":"ebf3a27dec061cf0"}[chunkId] + ".js";
};